module.exports = __webpack_public_path__ + "img/hakka-child.64b1f535.gif";